/** styles */
import "./admin-layout.scss";

/** layouts */
import BaseLayout from "../base-layout/base-layout";

const AdminLayout = ({ title, children }) => {
  return <BaseLayout title={title} children={children}></BaseLayout>;
};

export default AdminLayout;
